import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, PencilIcon, PlusCircleIcon, Typography } from '@blade/ui-kit'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { referralCodeAtom } from '@root/entities/referral'
import { ReferralCodeInline } from '@root/entities/referral/ui/referral-code-inline'
import {
  openChangeReferralCodeDialogAction,
  openCreateReferralCodeDialogAction,
} from '@root/features/referral/atoms'

type ReferralSideInfoProps = {}

export const ReferralSideInfo: React.FC<ReferralSideInfoProps> = () => {
  const { t } = useTranslation()
  const [network] = useAtom(selectedNetworkAtom)
  const [referralCode] = useAtom(referralCodeAtom)
  const openCreateReferralCodeDialog = useAction(
    openCreateReferralCodeDialogAction,
  )
  const openChangeReferralCodeDrawer = useAction(
    openChangeReferralCodeDialogAction,
  )

  if (!referralCode) {
    return (
      <ButtonWrapper
        size="h24"
        radius="rounded"
        variant="ghost"
        iconLeft={<PlusCircleIcon size={14} />}
        onClick={() => openCreateReferralCodeDialog()}
      >
        {t('referral.add-referral-code')}
      </ButtonWrapper>
    )
  }

  return (
    <Root>
      <Label variant="body4-medium">
        {t('referral.network-referral-code', {
          network: Network.label(network),
        })}
      </Label>
      <ReferralCodeInline network={network} code={referralCode} />
      <Button
        radius="rounded"
        size="h20"
        variant="ghost"
        iconLeft={<PencilIcon />}
        onClick={() => openChangeReferralCodeDrawer()}
      >
        {t('common.edit')}
      </Button>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  margin-right: 10px;
`

const Label = styled(Typography)`
  color: var(--text-9);
`

const ButtonWrapper = styled(Button)`
  margin-right: 10px;
  font-weight: 500;
  color: var(--primary-9);
  &:hover {
    color: var(--primary-9);
  }
`
